import { Component } from "react"

/* Modal */
import Modal from "react-modal"

/* Components */
import { Input } from "../components"

/* Icons */
import { LoadingOutlined } from "@ant-design/icons"

/* REST API */
import { create } from "../api/User"

/* Sweet alert */
import Swal from "sweetalert2"


/* Widget Create User */
class CreateUser extends Component {

    constructor() {
        super()

        this.state = {
            visible: false,
            name: "",
            email: "",
            password: "",
            error: "",
            waiting: false
        }
    }

    /* Open action */
    open = () => {

        /* Open Modal */
        this.setState({ visible: true })
    }

    /* Close action */
    close = () => {

        /* Close Modal */
        this.setState({
            visible: false,
            name: "",
            email: "",
            password: "",
            error: "",
            waiting: false
        })
    }

    /* Clear Errors */
    clear = () => {
        this.setState({ error: "" })
    }

    /* Create action */
    create = () => {

        /* Fields */
        const { name, email, password } = this.state
        const { reload } = this.props

        /* Check Name */
        if (name === "" || name === null || name === undefined) {
            this._name.error("Введите имя")
            return
        }

        /* Check Email */
        if (email === "" || email === null || email === undefined) {
            this._email.error("Введите Email")
            return
        }

        /* Check Email */
        if (/\S+@\S+\.\S+/.test(email) === false) {
            this._email.error("Неверный формат Email")
            return
        }

        /* Check Password */
        if (password === "") {
            this._password.error("Введите пароль")
            return
        }

        /* Check Password */
        if (password.length < 8) {
            this._password.error("Пароль должен быть больше 8 символов")
            return
        }

        /* Start Loading */
        this.setState({ waiting: true })

        /* Clear Error */
        this._name.error("")
        this._email.error("")
        this._password.error("")

        /* SEND REQUEST to REST API */
        create({ name, email, password }).then(response => {
            if (response.status === 200) {

                Swal.fire({
                    html: `<p class="notification">Пользователь успешно добавлена!</p>`,
                    icon: "success",
                    color: "white",
                    background: "black",
                    showConfirmButton: false,
                    position: "top-right",
                    timer: 2000,
                    width: 400,
                    backdrop: false,
                    customClass: { icon: "notification-icon", htmlContainer: "notification-html", popup: "notification-popup" }
                })

                this.setState({ visible: false, name: "", email: "", password: "", error: "" })

                /* Reload */
                reload()

            }
            else if (response.status === 403) {
                this.setState({ error: "Пользователь уже существует" })
            }
            else {
                this.setState({ error: "Что-то пошло не так! Попробуйте позднее." })
            }
        }).catch(() => {
            this.setState({ error: "Что-то пошло не так! Попробуйте позднее." })
        }).finally(() => {
            this.setState({ waiting: false })
        })

    }

    /* Draw button */
    _button = () => {

        const { waiting } = this.state

        if (waiting) {
            return <div className="button"><LoadingOutlined /></div>
        }

        return <div onClick={() => this.create()} className="button">Создать</div>
    }


    render = () => {

        /* Fields */
        const { visible, name, email, password, error } = this.state

        return (
            <Modal
                isOpen={visible}
                onRequestClose={() => this.close()}
                className="create-user-modal"
                overlayClassName="create-user-overlay"
                closeTimeoutMS={200}
            >

                {/* Draw Header */}
                <div className="create-user-header">
                    <h2>Добавить пользователя</h2>
                    <div onClick={() => this.close()} className="create-user-close">
                        <img src="/images/close.png" alt="Close" />
                    </div>
                </div>

                {/* Draw Modal */}
                <div className="create-user-content">

                    {/* Draw Inputs */}
                    <Input label="Имя" ref={ref => this._name = ref} value={name} clear={() => this.clear()} onChange={event => this.setState({ name: event.target.value })} />
                    <Input label="Email" ref={ref => this._email = ref} value={email} clear={() => this.clear()} onChange={event => this.setState({ email: event.target.value })} />
                    <Input label="Придумайте пароль" ref={ref => this._password = ref} value={password} clear={() => this.clear()} onChange={event => this.setState({ password: event.target.value })} secure />

                    {/* Draw Error */}
                    <div className="error">{error}</div>

                    {/* Draw Button */}
                    {this._button()}

                </div>

            </Modal>
        )
    }

}

export default CreateUser